import styled from 'styled-components';

export const BodyBold = styled.p`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.06rem;
  margin-bottom: 0;
  align-self: center;
`;

export const BodyLight = styled.p`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.06rem;
  margin-bottom: 0;
  align-self: center;
`;

export const Heading = styled.h3`
  font-weight: bold;
  font-size: 1.25rem;
  line-height: 1.875rem;
  margin-bottom: 0;
  align-self: center;
`;

export const Heading2 = styled.h1`
  font-weight: bold;
  line-height: 1.875rem;
  margin-bottom: 0;
`;
